import * as React from 'react';
// mui
import {
  Box,
  ListItem,
  ListItemButton,
  ListItemText,
  useMediaQuery,
  useTheme,
} from '@mui/material';
// icons
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
// redux
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store/store';
import { setTasks } from '../../store/slices/tasksSlice';
// axios
import api from '../../axios';
// types
import RecurringTask from '../../interfaces/RecurringTask.interface';
import Task from '../../interfaces/Task.interface';
import Event from '../../interfaces/Event.interface';
// components
import TaskCard from '../../components/ToDoPage/cards/TaskCard';
import ToDoForm from '../../components/ToDoPage/ToDoForm/ToDoForm';
import NoTask from '../../components/ToDoPage/NoTask';
import RecurringTaskCard from '../../components/ToDoPage/cards/RecurringTaskCard';
import EventCard from '../../components/ToDoPage/cards/EventCard';

type TaskTypes = 'task' | 'event' | 'recurring' | 'none' | 'form';

interface TodoResponse {
  type: TaskTypes;
  item: Task | Event | RecurringTask | null;
};

export default function ToDoPage() {
  // hooks
  const dispatch = useDispatch<AppDispatch>();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // local state
  const [ page, setPage ] = React.useState<TaskTypes>('form');

  const [ timePreference, setTimePreference ] = React.useState<number>(0);
  const [ energyPreference, setEnergyPreference ] = React.useState<number>(0);
  const [ excludedProjectIds, setExcludedProjectIds ] = React.useState<number[]>([]);
  const [ taskCounter, setTaskCounter ] = React.useState<number>(0);

  const [ itemData, setItemData ] = React.useState<TodoResponse>();
  
  const fetchItem = (time: number, energy: number, excludedProjectIds: number[]) => {
    api.post('/todo', {
      time,
      energy,
      excludedProjectIds: excludedProjectIds,
    })
      .then((res) => {
        console.log(res);
        let todoRes: TodoResponse = res.data;
        
        if (todoRes) {
          setTaskCounter(taskCounter + 1);
          setItemData(todoRes);
          setPage(todoRes.type);
        } else {
          throw new Error('API response did not contain data!');
        }
      })
      .catch(console.log);
  }

  const handlePreferencesSubmitted = (time: number, energy: number, excludedProjectIds: number[]) => {
    setTimePreference(time);
    setEnergyPreference(energy);
    setExcludedProjectIds(excludedProjectIds);
    fetchItem(time, energy, excludedProjectIds);
  }

  const handleBackToForm = () => {
    setPage('form');
    setTaskCounter(0);
  }

  const handleMoveToNextTask = () => {
    fetchItem(timePreference, energyPreference, excludedProjectIds);
  }

  const fetchTasks = async () => {
    api.get('/tasks/normalized/get')
      .then((res) => {
        console.log(res);
        const fetchedTasks: Task[] = res.data;

        dispatch(setTasks(fetchedTasks));
      })
      .catch(console.log);
  };

  React.useEffect(() => {
    // fetch tasks for displaying ancestry breadcrumbs and for dynamic modification of mini tasks
    fetchTasks();
  }, []);

  return (
    <Box>
      { page === 'form' &&
        <ToDoForm onPreferencesSubmitted={handlePreferencesSubmitted} />
      }

      { ((page === 'task' || page === 'recurring' || page === 'event') && itemData?.item) && (
        <React.Fragment>
          <ListItem sx={{ width: '100%', pl: '0 !important', pr: '0 !important', pt: isMobile ? 2 : '', pb: isMobile ? 0 : '' }}>
            <ListItemButton
              onClick={handleBackToForm}
              sx={{ color: 'grey', minWidth: '100px', borderRadius: '5px' }}
            >
              <KeyboardArrowLeftIcon /> BACK
            </ListItemButton>
            <ListItemText sx={{ color: 'grey', width: '100%', textAlign: 'center'}}>
              Task To Do
            </ListItemText> 
            <ListItemText sx={{ color: 'grey', minWidth: '100px' }}>
              Task #{taskCounter}
            </ListItemText>
          </ListItem>
          { itemData.type === 'task' &&
            <TaskCard onMoveToNextTask={handleMoveToNextTask} taskData={itemData.item as Task} />
          }
          { itemData.type === 'recurring' &&
            <RecurringTaskCard onMoveToNextTask={handleMoveToNextTask} recurringTaskData={itemData.item as RecurringTask} />
          }
          { itemData.type === 'event' &&
            <EventCard onMoveToNextTask={handleMoveToNextTask} eventData={itemData.item as Event} />
          }
        </React.Fragment>
      )}

      { page === 'none' &&
        <React.Fragment>
          <ListItem sx={{ width: '100%', pl: '0 !important', pr: '0 !important', pt: isMobile ? 2 : '', pb: isMobile ? 0 : '' }}>
            <ListItemButton
              onClick={handleBackToForm}
              sx={{ color: 'grey', minWidth: '100px', borderRadius: '5px' }}
            >
              <KeyboardArrowLeftIcon /> BACK
            </ListItemButton>
          </ListItem>

          <NoTask />

        </React.Fragment>
      }
    </Box>
  );
}
